/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DocIcon32Regular = forwardRef('DocIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M27 24.5a5.5 5.5 0 0 1-5.5 5.5h-11A5.5 5.5 0 0 1 5 24.5v-17A5.5 5.5 0 0 1 10.5 2h6.726a4 4 0 0 1 2.829 1.172l5.773 5.773A4 4 0 0 1 27 11.774V24.5ZM7 7.5A3.5 3.5 0 0 1 10.5 4H16v5.5a3.5 3.5 0 0 0 3.5 3.5H25v11.5a3.5 3.5 0 0 1-3.5 3.5h-11A3.5 3.5 0 0 1 7 24.5v-17ZM24.844 11H19.5A1.5 1.5 0 0 1 18 9.5V4.156a2 2 0 0 1 .64.43l5.774 5.774c.185.185.33.403.43.64Z" })));
});
